<template>
  <el-dialog title="未评估的学生" :visible.sync="dialogVisible" width="700px" :before-close="handleClose">
    <el-descriptions>
      <el-descriptions-item label="学年">{{ unAssessmentData.schoolYear || '-' }}</el-descriptions-item>
      <el-descriptions-item label="学期">{{ unAssessmentData.semester || '-' }}</el-descriptions-item>
      <!-- <el-descriptions-item label="考勤导入日期">苏州市</el-descriptions-item> -->
      <el-descriptions-item label="授课老师">
        <span v-for="item in unAssessmentData.teachersInfo" :key="item.mobile" class="teacher-item">{{ item.name }}</span>
      </el-descriptions-item>
      <el-descriptions-item label="课程名称">{{ unAssessmentData.courseName || '-' }}</el-descriptions-item>
    </el-descriptions>
    <ul class="table-head">
      <li>学生姓名</li>
      <li>班级</li>
    </ul>
    <el-scrollbar v-if="unAssessmentData.students" style="height: 200px; max-height: 500px;" wrap-class="scrollbar-wrapper">
      <ul class="table-content">
        <li v-for="(item, index) in unAssessmentData.students" :key="item.name + index">
          <span>{{ item.name }}</span>
          <span>{{ item.class }}</span>
        </li>
      </ul>
    </el-scrollbar>
    <div v-if="!unAssessmentData.students" class="tips">暂无未评估的学生</div>
  </el-dialog>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { isEmpty } from '@/utils'

const props = defineProps({
  visible: {
    type: Boolean,
    default: () => false
  },
  courseId: {
    type: [Number, String],
    default: () => ''
  },
  dialogData: {
    type: Object,
    default: () => {}
  }
})
const unAssessmentData = ref({})
const emit = defineEmits(['handleClose'])

const dialogVisible = computed(() => {
  return props.visible
})

function handleClose() {
  emit('update:visible', false)
}

onMounted(() => {
  console.log('isEmpty(props.dialogData)', isEmpty(props.dialogData))
  console.log('props.dialogData', props.dialogData)

  if (!isEmpty(props.dialogData)) {
    unAssessmentData.value = props.dialogData
  }
})

</script>

<style scoped lang="scss">
ul {
  margin: 0;
  padding: 0;
}

.table-head {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  // background-color: #eee;
  border: 1px solid #dfe6ec;
  border-bottom: none;

  li {
    list-style: none;
    flex: 1;
    text-align: center;
    color: #333;
    padding: 12px 0;
    color: #909399;
    font-weight: bold;

    &:not(:last-child) {
      border-right: 1px solid #dfe6ec;
    }
  }
}

.table-content {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border: 1px solid #dfe6ec;

  li {
    width: 100%;
    list-style: none;
    display: flex;
    justify-content: flex-start;

    &:not(&:first-child) {
      border-top: 1px solid #dfe6ec;
    }

    span {
      flex: 1;
      text-align: center;
      padding: 10px 0;

      &:nth-child(1) {
        border-right: 1px solid #dfe6ec;
      }
    }
  }
}

.tips {
  padding: 20px 0;
  text-align: center;
  color: #ccc;
  border: 1px solid #dfe6ec;
}
</style>
